export { TransferGiftCardModal as default } from 'features/payment/account';
